import { getEntities, getEntity, getEntityOrder } from './_utils'

export const getReplies = getEntities('replies')
export const getReply = getEntity('replies')

export const getRepliesOrder = getEntityOrder('conversations')
export const getRepliesList = (state) => getRepliesOrder(state).map((id) => getReply(state, { id }))
